import React, { useState } from "react";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import { MdDryCleaning } from "react-icons/md";
import { GiSewingMachine } from "react-icons/gi";
import { TbIroningSteam } from "react-icons/tb";
import { BiSolidWasher } from "react-icons/bi";
import { FaTshirt } from "react-icons/fa";
import CustomPopupForm from "../../../component/customPopupModel";

const serviceIcons = {
  "Dry Cleaning": MdDryCleaning,
  "Wash & Fold": BiSolidWasher,
  Ironing: TbIroningSteam,
  Tailoring: GiSewingMachine,
};

function OrderView({ onClose, dialogDetails, onSubmit, showMismatchReport = true }) {
  const Icon = serviceIcons[dialogDetails?.service] || FaTshirt;
  const [open, setOpen] = useState(false);

  const handleSubmit = () => {
    setOpen(false);
    onSubmit(dialogDetails);
  };

  console.log("Dialog details in OrderView:", dialogDetails);
  
  const hasAdditional =
    Array.isArray(dialogDetails?.additionalItems) &&
    dialogDetails.additionalItems.length > 0;

  // --- NEW LOGIC: Extract Discount Data ---
  const breakdown = dialogDetails?.breakdown || {};
  const campaignDiscount = Number(breakdown.campaignDiscount || 0);
  const pricingTierDiscount = Number(breakdown.pricingTierDiscount || 0);

  return (
    <div className="w-full max-w-2xl mx-auto bg-white rounded-2xl shadow-xl flex flex-col max-h-[80vh]">
      {/* Header */}
      <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200 bg-gradient-to-r from-sky-600 to-sky-500 text-white">
        <div className="flex items-center gap-3 min-w-0">
          <div className="bg-white/10 rounded-full p-2 shrink-0">
            <Icon className="text-xl" />
          </div>
          <div className="flex flex-col min-w-0">
            <span className="text-xs uppercase tracking-wide text-slate-200">
              Order summary
            </span>
            <span className="text-base font-semibold truncate">
              {dialogDetails?.service}
            </span>
          </div>
        </div>
        <button
          onClick={onClose}
          aria-label="Close"
          className="rounded-full p-1 hover:bg-white/10 transition shrink-0"
        >
          <CloseIcon fontSize="small" />
        </button>
      </div>

      {/* Body */}
      <div className="flex-1 overflow-y-auto no-scrollbar bg-slate-50">
        <div className="px-5 py-4 space-y-4">
          {/* Customer + Meta */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {/* Customer */}
            <div className="bg-white rounded-xl border border-slate-100 px-3.5 py-3 flex items-center gap-3 min-w-0">
              <img
                src={dialogDetails?.customer_img}
                alt={dialogDetails?.customer_name}
                className="h-11 w-11 rounded-full object-cover border border-slate-200 shrink-0"
              />
              <div className="space-y-0.5 min-w-0">
                <p className="text-sm font-semibold text-slate-900 truncate">
                  {dialogDetails?.customer_name}
                </p>
                <p className="text-xs text-slate-500 truncate">
                  {dialogDetails?.contact || "No contact"}
                </p>
                <p className="text-xs text-slate-500 line-clamp-2 break-words">
                  {dialogDetails?.address}
                </p>
              </div>
            </div>

            {/* Order meta – stacked, no justify-between */}
            <div className="bg-white rounded-xl border border-slate-100 px-3.5 py-3 space-y-2 text-xs">
              {/* Order ID */}
              <div className="space-y-0.5">
                <p className="text-slate-500">Order ID</p>
                <p className="font-medium text-slate-900 break-words">
                  {dialogDetails?.order_id}
                </p>
              </div>

              {/* Status */}
              <div className="space-y-0.5">
                <p className="text-slate-500">
                  Status{" "}
                  <span className="inline-flex items-center justify-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-amber-50 text-amber-700">
                    {dialogDetails?.order_status}
                  </span>
                </p>
              </div>

              {/* Order date */}
              <div className="space-y-0.5">
                <p className="text-slate-500">Order date</p>
                <p className="font-medium text-slate-900">
                  {dialogDetails?.date}
                </p>
              </div>

              {/* Preferred slot */}
              <div className="space-y-0.5">
                <p className="text-slate-500">Preferred slot</p>
                <p className="font-medium text-slate-900 text-sm break-words">
                  {dialogDetails?.delivery_date} <br /> {dialogDetails?.delivery_time}
                </p>
              </div>
            </div>
          </div>

          {/* Summary strip */}
          <div className="bg-white rounded-xl border border-slate-100 px-3.5 py-2.5 flex flex-wrap items-center gap-3 text-sm">
            <div className="flex items-center gap-1.5">
              <span className="text-slate-500 text-xs">Quantity</span>
              <span className="font-semibold text-slate-900">
                {dialogDetails?.totalQuantity}{" "}
                {dialogDetails?.service === "Wash & Fold" ? "Pounds" : "Items"}
              </span>
            </div>
            {/* <span className="hidden h-4 w-px bg-slate-200 sm:block" /> */}
            {/* <div className="flex items-center gap-1.5">
              <span className="text-slate-500 text-xs">Total</span>
              <span className="font-semibold text-emerald-600">
                ${dialogDetails?.totalPrice}
              </span>
            </div> */}
            <span className="hidden h-4 w-px bg-slate-200 sm:block" />
            <div className="flex items-center gap-1.5">
              <span className="text-slate-500 text-xs">Service type</span>
              <span className="inline-flex items-center rounded-full bg-sky-50 px-2 py-0.5 text-[11px] font-medium text-sky-700">
                {dialogDetails?.service_type}
              </span>
            </div>
          </div>

          {/* Items */}
          <div className="bg-white rounded-xl border border-slate-100">
            <div className="flex items-center justify-between px-3.5 py-2.5 border-b border-slate-100">
              <p className="text-sm font-semibold text-slate-900">
                Items in order
              </p>
              <span className="text-[11px] text-slate-500">
                {dialogDetails?.items?.length || 0} item
                {dialogDetails?.items?.length > 1 ? "s" : ""}
                {hasAdditional &&
                  ` • +${dialogDetails.additionalItems.length} add-on`}
              </span>
            </div>

            {/* Base items */}
            {dialogDetails?.items?.map((item, idx) => {
              if (
                item.item_type === "TAILORING" &&
                Array.isArray(item.tailoring_types)
              ) {
                return item.tailoring_types.map((tailor, tIdx) => (
                  <div
                    key={`base-${idx}-${tIdx}`}
                    className="flex items-center justify-between px-3.5 py-2 text-sm border-b border-slate-50"
                  >
                    <div className="flex flex-col min-w-0">
                      <span className="text-slate-900 truncate">
                        {tailor.name}
                      </span>
                      <span className="text-[11px] text-slate-500">
                        Tailoring • Qty: {item.quantity}
                      </span>
                    </div>
                    <span className="font-medium text-slate-900 shrink-0">
                      ${tailor.price}
                    </span>
                  </div>
                ));
              }

              return (
                <div
                  key={`base-${idx}`}
                  className="flex items-center justify-between px-3.5 py-2 text-sm border-b border-slate-50"
                >
                  <div className="flex flex-col min-w-0">
                    <span className="text-slate-900 truncate">
                      {item.item_name}
                    </span>
                    <span className="text-[11px] text-slate-500">
                      Qty: {item.quantity}
                    </span>
                  </div>
                  <span className="font-medium text-slate-900 shrink-0">
                    ${item.price}
                  </span>
                </div>
              );
            })}

            {/* Additional items */}
            {hasAdditional && (
              <>
                <div className="px-3.5 py-2 text-[11px] font-semibold uppercase tracking-wide text-slate-400 bg-slate-50 border-y border-slate-100">
                  Additional items
                </div>
                {dialogDetails.additionalItems.map((item, idx) => (
                  <div
                    key={`add-${idx}`}
                    className="flex items-center justify-between px-3.5 py-2 text-sm border-b last:border-b-0 border-slate-50 bg-slate-50/70"
                  >
                    <div className="flex flex-col min-w-0">
                      <span className="text-slate-900 truncate">
                        {item.name}
                      </span>
                      <span className="text-[11px] text-slate-500">
                        Qty: {item.quantity} • ${item.unit_price} each
                      </span>
                    </div>
                    <span className="font-medium text-slate-900 shrink-0">
                      ${item.total_price}
                    </span>
                  </div>
                ))}
              </>
            )}
          </div>

          {/* --- NEW SECTION: Discount Breakdown --- */}
          {(campaignDiscount > 0 || pricingTierDiscount > 0) && (
            <div className="bg-white rounded-xl border border-slate-100 overflow-hidden">
               <div className="px-3.5 py-2 bg-slate-50/50 border-b border-slate-100">
                 <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Discount Breakdown</p>
               </div>
               <div className="px-3.5 py-3 space-y-2">
                 {campaignDiscount > 0 && (
                   <div className="flex items-center justify-between text-sm">
                     <span className="text-emerald-700 font-medium">Campaign Discount</span>
                     <span className="text-emerald-700 font-bold">- ${campaignDiscount.toFixed(2)}</span>
                   </div>
                 )}
                 {pricingTierDiscount > 0 && (
                   <div className="flex items-center justify-between text-sm">
                     <span className="text-emerald-700 font-medium">Tier Discount</span>
                     <span className="text-emerald-700 font-bold">- ${pricingTierDiscount.toFixed(2)}</span>
                   </div>
                 )}
               </div>
            </div>
          )}

          {/* Notes */}
          <div className="bg-white rounded-xl border border-slate-100 px-3.5 py-3">
            <p className="text-sm font-semibold text-slate-900 mb-1">
              Special instructions
            </p>
            <p className="text-sm text-slate-600 whitespace-pre-line break-words">
              {dialogDetails?.laundryNotes?.trim()
                ? dialogDetails.laundryNotes
                : "No special instructions added."}
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      {showMismatchReport && (
      <div className="px-5 py-3 border-t border-slate-200 bg-white flex justify-end">
        <button
          type="button"
          onClick={() => {
            if (dialogDetails?.isMismatchExist) return;
            setOpen(true);
          }}
          disabled={dialogDetails?.isMismatchExist}
          className={`inline-flex items-center justify-center w-full md:w-[230px] rounded-full text-sm font-semibold shadow-sm transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500
          ${
            dialogDetails?.isMismatchExist
              ? "bg-slate-100 text-slate-400 cursor-not-allowed"
              : "bg-sky-600 text-white hover:bg-sky-700"
          }`}
          style={{ height: 42 }}
        >
          {dialogDetails?.isMismatchExist
            ? "Mismatch already reported"
            : "Report order mismatch"}
        </button>
      </div>
      )}

      {showMismatchReport && (
      <CustomPopupForm
        isOpen={open}
        handleClose={() => setOpen(false)}
        dialogType="miss-match-order"
        dialogDetails={{
          order_id: dialogDetails?.id,
          service_type: dialogDetails?.service,
          additionalItems: dialogDetails?.additionalItems,
        }}
        onSubmit={handleSubmit}
      />
      )}
    </div>
  );
}

export default OrderView;
